<template>
  <div class="px-5 py-5">
    <div  class="flex flex-col center-content mb-5">
      <p class="font-bold text-2xl">My Dashboard</p>
    </div>

    <div class="flex flex-col sm:flex-row mb-5 ">
      <div>
        <a class="text-pink" :href="startCampaignLink" title="Create Annual Campaign">Start New Campaign</a>&nbsp; |&nbsp;
      </div>
      <div>
        <a class="text-pink" href="#" @click="getCampaigns" :title="campaignTypeText">{{campaignTypeText}}</a>&nbsp; | &nbsp;
      </div>
      <div>
        <a class="text-pink" href="#campaignData" v-smooth-scroll> Campaign Data</a>
      </div>
    </div>

    <div class="flex flex-col space-y-5">
      <campaign-detail-card v-for="campaign in campaigns"
                            :key="campaign.id"
                            :campaign="campaign"
                            :admin="this.admin">
      </campaign-detail-card>
    </div>

    <p v-show="donations.length > 0" class="mt-5 text-center"><span class="font-bold">Recent Donations</span></p>

    <div v-show="donations.length > 0" class="hidden mt-5 sm:block">
      <div class="align-middle inline-block min-w-full border-b border-l border-r border-gray-200">
        <table class="min-w-full table-auto">
          <thead>
          <tr class="border-t border-gray-200">
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <span class="lg:pl-2">Donor</span>
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Amount
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Campaign
            </th>
            <th class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Date
            </th>
          </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-100">
           <donation-dashboard-list v-for="donation in donations" :donation="donation" :key="donation.id"></donation-dashboard-list>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <campaign-stats v-if="active"/>

</template>

<script>


import CampaignDetailCard from "./CampaignDetailCard";
import DonationDashboardList from "./DonationDashboardList";
export default {
  components: {
    DonationDashboardList,
    CampaignDetailCard
  },
  data() {


    return {
      admin: false,
      campaigns: [],
      donations: [],
      active: true,

    }
  },
  created() {
    axios.get('/get-active-campaigns')
        .then(response => {
          this.campaigns =  response.data.campaigns
          this.donations =  response.data.donations
          this.admin =  response.data.admin
        })
  },
  computed: {
    startCampaignLink() {
      if (this.admin == false) {
        return 'https://side-out.org/start-a-fundraiser/'
      }
      return '/admin/create-annual-campaign'
    },
    campaignTypeText() {
      if (this.active == false) {
        return 'View Active Campaigns'
      }
      return 'View Past Campaigns'
    },
  },
  methods: {
    getCampaigns() {
      this.active = !this.active
      let link = '/get-active-campaigns'
      if (this.active == false) {
        link = '/get-inactive-campaigns'
      }
      axios.get(link)
          .then(response => {
            this.campaigns =  response.data.campaigns
          })
    },
  },
}
</script>
